<template>
	<div>
		<div class="display-flex flex-justify-space-between on-boarding-step-wrapper">
			<div class="display-flex flex-column flex-justify-space-between">
				<div>
					<div class="on-boarding-step-explanation-text">
						Notifications are triggered by an event or by data sent from your apps. You<br />can receive them in the browser, in an email,
						or in Slack. They let<br />you take action in the context of what happened.
					</div>
				</div>
				<div>
					<div class="on-boarding-step-explanation-text bold mt-2">Try it</div>
					<div class="on-boarding-step-explanation-text mb-4">Click below, then click the notification when it pops up</div>
					<AnemicButton @click="sendFakeNotification" tile class="on-boarding-step-finish-step-button">
						Send me a test notification
					</AnemicButton>
				</div>
			</div>
			<div class="image-container">
				<v-img :src="OnBoardingNotificationsImage" />
			</div>
		</div>
		<BuilderNotification
			:titleArr="notificationTitleArr"
			@click.native="runFakeNotification"
			class="fake-notification-container"
			takeActionTitle="See what it can do"
			:class="{ show: showFakeNotification }"
		/>
		<InAppFlowRun
			v-if="showFlowRun"
			:isActive="showFlowRun"
			:hashId="notificationFlowRunExampleHash"
			@status-changed="onNotificationFinished"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Modes } from '@/common.js';
import InAppFlowRun from '@/components/common/InAppFlowRun.vue';
import OnBoardingNotificationsImage from '@/assets/icons/on-boarding-notifications.png';
import BuilderNotification from '@/components/BlockEditorNotification/PreviewTabs/BuilderNotification.vue';
import { PROD_FAKE_NOTIFICATION_FLOW_HASH_ID, STAGING_FAKE_NOTIFICATION_FLOW_HASH_ID } from '../../../../on-boarding-service.js';

export default {
	name: 'OnBoardingGetToKnowNotifications',
	props: { stepDetails: { type: Object } },
	components: {
		InAppFlowRun,
		BuilderNotification,
	},
	computed: {
		...mapGetters(['user']),
		notificationTitleArr() {
			return [{ text: `Hello ${this.user.first_name},`, isBold: true }, { text: 'you just received your first notification' }];
		},
		isCompleted() {
			return this.stepDetails.isCompleted;
		},
		notificationFlowRunExampleHash() {
			if (process.env.VUE_APP_PLY_ENV === Modes.Production) {
				return PROD_FAKE_NOTIFICATION_FLOW_HASH_ID;
			} else {
				return STAGING_FAKE_NOTIFICATION_FLOW_HASH_ID;
			}
		},
	},
	methods: {
		markAsComplete() {
			this.$emit('mark-step-as-done', this.stepDetails);
		},
		sendFakeNotification() {
			this.showFakeNotification = true;
		},
		runFakeNotification() {
			const url = new URL(window.location.href);
			url.search = `?name=${this.user.first_name}`;
			window.history.pushState('', '', url.toString());
			this.showFlowRun = true;
			this.showFakeNotification = false;
		},
		clearSearchString() {
			const url = new URL(window.location.href);
			url.search = '';
			window.history.pushState('', '', url.toString());
		},
		onNotificationFinished(status) {
			if (status === 'done') {
				this.showFlowRun = false;
				this.markAsComplete();
				this.clearSearchString();
			} else if (['canceled', 'error'].includes(status)) {
				this.showFlowRun = false;
				this.clearSearchString();
			}
		},
	},
	created() {},
	data() {
		return {
			showFlowRun: false,
			showFakeNotification: false,
			OnBoardingNotificationsImage,
		};
	},
};
</script>

<style scoped lang="scss">
.image-container {
	width: 433px;
	height: 257px;
}
.bold {
	font-weight: bold;
}
.fake-notification-container {
	&.show {
		right: 30px;
	}
	top: 22px;
	z-index: 100;
	right: -400px;
	border: unset;
	position: fixed;
	transition: 0.7s;
	border-radius: 8px;
	&:hover {
		cursor: pointer;
		transition: 0.3s;
		box-shadow: 2px 5px 9px var(--shadow-color);
	}
}
</style>
